// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class NoteConditionRelationshipModel {
    static getAttributeTypeMap() {
        return NoteConditionRelationshipModel.attributeTypeMap;
    }
}
NoteConditionRelationshipModel.discriminator = undefined;
NoteConditionRelationshipModel.attributeTypeMap = [
    {
        "name": "conditionTypeId",
        "baseName": "conditionTypeId",
        "type": "number"
    },
    {
        "name": "conditionCode",
        "baseName": "conditionCode",
        "type": "string"
    },
    {
        "name": "conditionDescription",
        "baseName": "conditionDescription",
        "type": "string"
    },
    {
        "name": "conditionCompletedDate",
        "baseName": "conditionCompletedDate",
        "type": "Date"
    },
    {
        "name": "conditionCompletedBy",
        "baseName": "conditionCompletedBy",
        "type": "number"
    },
    {
        "name": "conditionCompleted",
        "baseName": "conditionCompleted",
        "type": "boolean"
    },
    {
        "name": "conditionCreatedDate",
        "baseName": "conditionCreatedDate",
        "type": "Date"
    }
];
//# sourceMappingURL=noteConditionRelationshipModel.js.map